import "./App.css";
import ChangeLang from "./components/ChangeLang";
import Menu from "./components/Menu";
import { useEffect, useState } from "react";
import Slider from "./components/Slider";
import Footer from "./components/Footer";

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const theme = isDarkMode ? "dark" : "light"; // ✅ تصحيح التخزين
    localStorage.setItem("theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };
  if (showSplash) {
    return (
      <div
        className="d-flex justify-content-center align-items-center vh-100"
        style={{
          backgroundColor: "black",
        }}
      >
        <img
          className=""
          src="/images/spp.jpeg"
          alt="Splash"
          style={{ borderRadius: "10px", width: "90%", height: "70vh" }}
        />
      </div>
    );
  }
  return (
    <div
      className="App position-relative"
      style={{
        backgroundImage: "url('/images/home-pg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <ChangeLang
        onSearch={setSearchTerm}
        isDarkMode={isDarkMode}
        onToggleTheme={toggleTheme}
      />
      <Slider isDarkMode={isDarkMode} />
      <Menu searchTerm={searchTerm} isDarkMode={isDarkMode} />
      <Footer isDarkMode={isDarkMode} />
    </div>
  );
}

export default App;
